import { ref } from "vue";
import { useStripeService } from "../../cbi-generator/frontend/composables/useStripeFrontendService";
import type { StripeConfiguration } from "../../cbi-generator/generated/dto/StripeConfiguration";
import { loadStripe, Stripe } from "@stripe/stripe-js";

export const useStripe = () => {
  const stripe = ref<Stripe | null>(null);
  const constants = ref<StripeConfiguration | null>(null);
  const stripeService = useStripeService();
  const load = async () => {
    if (stripe.value != null) return;
    constants.value = await stripeService.configurationPublic();
    stripe.value = await loadStripe(constants.value.publicKey, {
      stripeAccount: constants.value.account,
      apiVersion: constants.value.apiVersion,
      locale: "en",
    });
  };
  return {
    load,
    constants,
    stripe,
  };
};
